import { buildApiUrl } from "../../services/apiConfig";

const fetchAgents = async () => {
  try {
    const response = await fetch(buildApiUrl('AGENTS', '/'));
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching agents:', error);
    return [];
  }
};


const fetchDomains = async () => {
  try {
    const response = await fetch(buildApiUrl('AUTH', '/fetch/domains'));
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching domains:', error);
    return [];
  }
};

const fetchUseCases = async () => {
  try {
    const response = await fetch(buildApiUrl('AUTH', '/fetch/use_cases'));
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching use cases:', error);
    return [];
  }
};


const fetchWidgetsAndTabs = async (useCaseId, userId) => {
  try {
    const response = await fetch(buildApiUrl('AUTH', `/api/widgets/by-tabs?use_case_id=${useCaseId}&user_id=${userId}`));
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    const data = await response.json();
    return {
      widgets: data.tabs.widgets,
      tabs: data.tabs.tab_name
    };
  } catch (error) {
    console.error('Error fetching widgets and tabs:', error);
    return { widgets: [], tabs: [] };
  }
};

const fetchTools = async () => {
  try {
    const response = await fetch(buildApiUrl('AUTH', '/fetch/tools'));
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching tools:', error);
    return [];
  }
};

const fetchActiveAgents = async (userId) => {
  try {
    const response = await fetch(buildApiUrl('AGENTS', `/user/${userId}/active_agents`));
    if (!response.ok) throw new Error(`API responded with status: ${response.status}`);
    const data = await response.json();
    return Array.isArray(data) ? data : (data.active_agents ?? data.data ?? []);
  } catch (error) {
    console.error('Error fetching active agents:', error);
    return [];
  }
};

const selectAgent = async (userId, agentVersionId) => {
  console.log(JSON.stringify({ user_id: userId, agent_version_ids: [agentVersionId] }));
  const response = await fetch(buildApiUrl('AGENTS', '/select_agents'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, agent_version_ids: [agentVersionId] }),
  });
  console.log(response);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.message || `API responded with status: ${response.status}`);
  }
  return response.json();
};

const registerAgent = async (payload) => {
  const response = await fetch(buildApiUrl('AGENTS', '/register_agent'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    const detail = Array.isArray(err.detail)
      ? err.detail.map(d => `${d.loc?.join('.')} — ${d.msg}`).join('; ')
      : err.detail || err.message;
    throw new Error(detail || `API responded with status: ${response.status}`);
  }
  return response.json();
};

const deactivateAgent = async (userId, agentVersionId) => {
  const response = await fetch(buildApiUrl('AGENTS', '/remove_agents'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, agent_version_ids: [agentVersionId] }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.message || `API responded with status: ${response.status}`);
  }
  return response.json().catch(() => ({}));
};

const deleteAgent = async (agentId) => {
  const response = await fetch(buildApiUrl('AGENTS', `/${agentId}`), {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.message || `API responded with status: ${response.status}`);
  }

  return response.json().catch(() => ({}));
};

export {
  fetchDomains,
  fetchUseCases,
  fetchTools,
  fetchWidgetsAndTabs,
  fetchAgents,
  fetchActiveAgents,
  selectAgent,
  deactivateAgent,
  registerAgent,
  deleteAgent
};

export default {
  fetchDomains,
  fetchUseCases,
  fetchTools,
  fetchWidgetsAndTabs,
  fetchAgents,
  fetchActiveAgents,
  selectAgent,
  deactivateAgent,
  registerAgent,
  deleteAgent
};
